module.exports = __webpack_public_path__ + "img/16l010-11.efc17ffe.png";